import { useGoogleLogin } from "@react-oauth/google";
import { useAuthActions } from "@hooks";
import { SecondaryButton } from "@components";
import googleIcon from "@assets/google.svg";
import axios from "axios";

// TODO: move to another file
const verifyGoogleOAuth = async (accessToken) =>{
  const response = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
  return response.data;
};

const AuthGoogleBtn = () => {
  const { googleOAuthLogin } = useAuthActions();
  const { isLoading, loginWithGoogle } = googleOAuthLogin;

  const responseSuccess = async (tokenResponse) => {
    try {
      const data = await verifyGoogleOAuth(tokenResponse.access_token);
      const userData = {
        firstName: data.given_name.trim(),
        lastName: data.family_name,
        oauthId: data.sub,
        email: data.email,
        oauthAvatar: data.picture,
        oauthType: "GOOGLE",
      };
      loginWithGoogle(userData);
    } catch (error) {
      console.error("Error verifying user token with Google", error);
    }
  };

  const responseError = (error) => {
    console.log(error);
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (response) => responseSuccess(response),
    onError: (errorResponse) => responseError(errorResponse),
  });

  return (
    <SecondaryButton
      isLoading={isLoading}
      onClick={() => handleGoogleLogin()}
      icon={googleIcon}
      width="full"
    >
      Google
    </SecondaryButton>
  );
};

export default AuthGoogleBtn;
